import { takeLatest, all, put, fork } from 'redux-saga/effects'

import * as actions from '../actions/actions'

export default function* progressSaga() {
  yield all([
    fork(watchProgressStartRequest),
    fork(watchProgressStopRequest)
  ]);
}

function* watchProgressStartRequest() {
  yield takeLatest(
    actions.PROGRESS_START_REQUEST,
    progressStartRequest
  )
}

function* progressStartRequest() {
  yield put({
    type: actions.PROGRESS_START
  })
}

function* watchProgressStopRequest() {
  yield takeLatest(
    actions.PROGRESS_STOP_REQUEST,
    progressStopRequest
  )
}

function* progressStopRequest() {
  yield put({
    type: actions.PROGRESS_STOP
  })
}